import React from 'react';
import './GameEndedByHostOverlay.css';

function GameEndedByHostOverlay({onMainMenu}) {
  const handleClick = () => {
    window.__skipBeforeUnload = true;
    onMainMenu();
  };

  return (
    <div className="game-ended-by-host-overlay">
      <h2 className="game-ended-by-host-title">Игра прервана</h2>
      <p className="game-ended-by-host-text">
        Создатель лобби завершил игру
      </p>
      <button className="game-ended-by-host-button" onClick={handleClick}>
        В главное меню
      </button>
    </div>
  );
}

export default GameEndedByHostOverlay;
